import React from 'react'
import PDIComponent from '../pdi/PDIComponent'

export const FiktifCikis = () => {
    return <PDIComponent title="Fiktif Çıkış" radioItems={["Fiktif Çıkış", "Hasar Bildir"]} defaultRadio="Fiktif Çıkış" showSwitch={true} api="/fiktif-cikis" modalArea="Fiktif Çıkış" />
}
